var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:_vm.key,staticClass:"random-img bg-lighter",style:({ backgroundImage: ("url(" + _vm.image + ")") })})}
var staticRenderFns = []

export { render, staticRenderFns }